// import subAPI from '@/api/init';
import { DEFAULT_DATE } from './constants';

/**
 * @description Check if value is empty
 * @param {*} value - Whatever you want.
 * @return {boolean}
 */
const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0) ||
  (Object.entries(value).length === 0 && value.constructor === Object);

/**
 * @description Set default authorization header
 * @param {string} token - Bear Token (JWT)
 */
const setAuthToken = (token) => {
  if (token) {
    // subAPI.defaults.headers['Authorization'] = token;
  } else {
    // delete subAPI.defaults.headers['Authorization'];
  }
};

/**
 * @description Set default authorization header
 * @param {Object} rawObj - Original object
 * @param {Array.<String>} allowed - Array of strings containing proptery key whitelisted
 */
const whiteListedKeys = ({ rawObj, allowed }) => {
  const filtered = Object.keys(rawObj)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = rawObj[key];
      return obj;
    }, {});

  return filtered;
};

/**
 * @description Return shsorted date
 * @param {Object} date - new Date instance long form.
 * @param {String}
 */
const returndate = ({ date }) => {
  if (date === DEFAULT_DATE || isEmpty(date)) return 'N/A';
  const newDate = new Date(date).toISOString().slice(0, 10);
  return newDate;
};

/**
 * Random text to use as a placeholder
 */
const randomText =
  'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repudiandae, impedit eum quaerat consequuntur eius nisi illum error provident. Quibusdam nam debitis voluptatibus praesentium,asperiores doloremque alias harum a esse veritatis!';

export default { returndate, isEmpty, randomText, whiteListedKeys, setAuthToken };
